import { Badge, Table, Text } from "@mantine/core";
import type { AssistantUsageLogText } from "@/locales/assistant-usage-log";
import type { UsageLogRowDto } from "@/types/ai-assistant-usage-log";
import { formatWita } from "./failover-insights.logic";
import {
	formatCount,
	formatLatency,
	STATUS_COLOR,
	statusLabel,
	VENDOR_COLOR,
	vendorLabel,
} from "./usage-log.logic";

interface Props {
	rows: UsageLogRowDto[];
	t: AssistantUsageLogText;
	lang: "id" | "en";
}

/** Tabel log penggunaan: satu baris = satu giliran. Hanya metadata, tanpa isi percakapan. */
export function UsageLogTable({ rows, t, lang }: Props) {
	if (rows.length === 0)
		return (
			<Text size="sm" c="dimmed" data-usage-log-empty>
				{t.empty}
			</Text>
		);
	return (
		<Table.ScrollContainer minWidth={760}>
			<Table striped verticalSpacing="xs" fz="sm" data-usage-log-table>
				<Table.Thead>
					<Table.Tr>
						<Table.Th>{t.colTime}</Table.Th>
						<Table.Th>{t.colVendor}</Table.Th>
						<Table.Th>{t.colModel}</Table.Th>
						<Table.Th ta="right">{t.colLatency}</Table.Th>
						<Table.Th ta="right">{t.colInput}</Table.Th>
						<Table.Th ta="right">{t.colOutput}</Table.Th>
						<Table.Th>{t.colStatus}</Table.Th>
						<Table.Th>{t.colKind}</Table.Th>
					</Table.Tr>
				</Table.Thead>
				<Table.Tbody>
					{rows.map((row) => (
						<Table.Tr key={row.id} data-usage-log-row={row.vendor}>
							<Table.Td>{formatWita(row.at)}</Table.Td>
							<Table.Td>
								<Badge color={VENDOR_COLOR[row.vendor]} variant="light">
									{vendorLabel(row.vendor, t)}
								</Badge>
							</Table.Td>
							<Table.Td>
								{row.model ?? (
									<Text span size="xs" c="dimmed">
										{t.modelUnknown}
									</Text>
								)}
							</Table.Td>
							<Table.Td ta="right">
								{formatLatency(row.latencyMs, lang)}
							</Table.Td>
							<Table.Td ta="right">
								{formatCount(row.inputTokens, lang)}
							</Table.Td>
							<Table.Td ta="right">
								{formatCount(row.outputTokens, lang)}
							</Table.Td>
							<Table.Td>
								<Badge color={STATUS_COLOR[row.status]} variant="light">
									{statusLabel(row.status, t)}
								</Badge>
							</Table.Td>
							<Table.Td>
								{row.modality === "voice" ? t.kindVoice : t.kindText}
							</Table.Td>
						</Table.Tr>
					))}
				</Table.Tbody>
			</Table>
		</Table.ScrollContainer>
	);
}
